export default __webpack_public_path__ + "static/media/snark-dark-roast.55dfd2df.png";